export default __webpack_public_path__ + "static/media/icon-connect-customers.91c64b2a.svg";